import { Label } from "radix-ui";
import { useId, type InputHTMLAttributes, type ReactNode, type Ref } from "react";

export interface TextFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "size"> {
  label: ReactNode;
  /** Подпись видна только читалке: поле скана в шапке, поиск. */
  hideLabel?: boolean;
  hint?: ReactNode;
  error?: ReactNode;
  /** scan: рамка 2 px и цифры одной ширины. */
  variant?: "default" | "scan";
  ref?: Ref<HTMLInputElement>;
}

export function TextField({ label, hideLabel, hint, error, variant = "default", id, className, ...rest }: TextFieldProps) {
  const autoId = useId();
  const inputId = id ?? autoId;
  const hintId = hint ? `${inputId}-hint` : undefined;
  const errorId = error ? `${inputId}-error` : undefined;
  const describedBy = [hintId, errorId].filter(Boolean).join(" ") || undefined;
  return (
    <div className={className ? `w-field ${className}` : "w-field"}>
      <Label.Root htmlFor={inputId} className={hideLabel ? "w-visually-hidden" : "w-field-label"}>
        {label}
      </Label.Root>
      <input
        id={inputId}
        className="w-input"
        data-variant={variant === "default" ? undefined : variant}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
        {...rest}
      />
      {hint ? (
        <span id={hintId} className="w-field-hint">
          {hint}
        </span>
      ) : null}
      {error ? (
        <span id={errorId} className="w-field-error" role="alert">
          {error}
        </span>
      ) : null}
    </div>
  );
}
